import { useDragLayer } from "react-dnd"
import { MISSION_TABLE_FLIGHT, MissionDragItem } from "./useMissionTableDnD"

export const MissionDragChip = () => {
    const { isDragging, item, currentOffset } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging() && monitor.getItemType() === MISSION_TABLE_FLIGHT,
        item: monitor.getItem() as MissionDragItem | null,
        currentOffset: monitor.getClientOffset(),
    }))

    if (!isDragging || !item || !currentOffset) return null

    return (
        <div
            style={{
                left: currentOffset.x + 12,
                top: currentOffset.y + 12,
                zIndex: 9999,
            }}
            className="fixed bg-gray-600 text-white text-sm rounded-lg px-3 py-1.5 shadow-dp4 flex items-center gap-2 pointer-events-none"
        >
            <span>{item.date}</span>
            {item.droneName && <span className="text-gray-400">{item.droneName}</span>}
        </div>
    )
}
